module.exports = __webpack_public_path__ + "static/media/vegitables_10.48fdd7ae.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_10.csv
// module id = 592
// module chunks = 0